import type { ReactNode } from "react";

import type { PropsWithStyleX } from "@/styles/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

const styles = stylex.create({
    balloonContent: {
        position: "absolute",
        zIndex: 20,
        fontWeight: 300,
        overflow: "visible",
        padding: "1rem",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "#cecece",
        pointerEvents: "all",
        backgroundColor: "white",
        borderRadius: "0.625rem",
        boxShadow: "0 0 3px rgba(0, 0, 0, 0.2)",
    },

    tail: {
        width: "2rem",
        height: "1rem",
        position: "absolute",

        "::before": {
            content: "",
            position: "absolute",
            borderLeftWidth: "13px",
            borderLeftStyle: "solid",
            borderLeftColor: "transparent",
            borderRightWidth: "13px",
            borderRightStyle: "solid",
            borderRightColor: "transparent",
            zIndex: 10,
        },
        "::after": {
            content: "",
            position: "absolute",
            borderLeftWidth: "1rem",
            borderLeftStyle: "solid",
            borderLeftColor: "transparent",
            borderRightWidth: "1rem",
            borderRightStyle: "solid",
            borderRightColor: "transparent",
            zIndex: 5,
            transform: "translateX(-2px)",
        },
    },

    top: {
        top: 0,
        "::before": {
            bottom: "100%",
            borderBottomWidth: "13px",
            borderBottomStyle: "solid",
            borderBottomColor: "white",
        },

        "::after": {
            bottom: "100%",
            borderBottomWidth: "15px",
            borderBottomStyle: "solid",
            borderBottomColor: "#cecece",
        },
    },

    bottom: {
        bottom: 0,
        "::before": {
            top: "100%",
            borderTopWidth: "13px",
            borderTopStyle: "solid",
            borderTopColor: "white",
        },

        "::after": {
            top: "100%",
            borderTopWidth: "15px",
            borderTopStyle: "solid",
            borderTopColor: "#cecece",
        },
    },

    left: {
        left: "15%",
    },

    center: {
        right: "50%",
    },

    right: {
        right: "15%",
    },
});

export type BalloonProps = PropsWithStyleX & {
    children?: ReactNode;
    isOpen: boolean;
    tailPosition?: "top" | "bottom";
    tailAlign?: "left" | "center" | "right";
    onMouseEnter?: (event: React.MouseEvent<HTMLElement>) => void;
    onMouseLeave?: (event: React.MouseEvent<HTMLElement>) => void;
};

export default function Balloon(props: BalloonProps) {
    return (
        props.isOpen && (
            <div
                {...stylex.props(styles.balloonContent, props.styleX)}
                onMouseEnter={props.onMouseEnter}
                onMouseLeave={props.onMouseLeave}
            >
                <div
                    {...stylex.props(
                        styles.tail,
                        props.tailAlign && styles[props.tailAlign],
                        props.tailPosition && styles[props.tailPosition],
                    )}
                />
                {props.children}
            </div>
        )
    );
}
